const testimonials = [
  {
    quote:
      "AKT Global transformed our vacation home into a top-rated listing. Revenue is up nearly 40%, and we finally sleep at night knowing guests are cared for.",
    name: "Elena M.",
    role: "Property Owner · Coastal Villa",
  },
  {
    quote:
      "The photography, the copy, the pricing strategy — every detail felt considered. It's the closest thing to hospitality-as-a-service I've experienced.",
    name: "David R.",
    role: "Multi-Property Investor",
  },
  {
    quote:
      "Their team responded to a guest issue at 2 a.m. as if it were their own home. That is the difference.",
    name: "Priya S.",
    role: "First-Time Host",
  },
];

export default function Testimonials() {
  return (
    <section
      data-testid="testimonials-section"
      className="relative bg-espresso py-24 md:py-32 lg:py-40 text-cream"
    >
      <div className="max-w-[1400px] mx-auto px-6 lg:px-12">
        <div className="text-xs tracking-[0.3em] uppercase text-brass mb-10">Owner Voices</div>
        <div className="grid grid-cols-1 lg:grid-cols-3 gap-x-12 gap-y-16">
          {testimonials.map((t, i) => (
            <div key={i} data-testid={`testimonial-${i}`} className="relative pl-2">
              <div className="font-serif text-brass text-7xl leading-none absolute -top-6 -left-2 select-none">&ldquo;</div>
              <p className="font-serif text-2xl lg:text-3xl leading-snug text-cream/95 relative">
                {t.quote}
              </p>
              <div className="mt-8 border-t border-cream/20 pt-4">
                <div className="text-sm text-cream">{t.name}</div>
                <div className="text-[10px] tracking-[0.2em] uppercase text-cream/50 mt-1">{t.role}</div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
